import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { OnboardingFlow, useOnboarding } from '@/components/engagement/OnboardingFlow';

import { useDashboardPersonalization } from '@/hooks/useDashboardPersonalization';
import { DashboardSections } from './sections/DashboardSections';
import { PersonalizationDebugger } from '@/components/personalization/PersonalizationDebugger';
import { ErrorFallback } from '@/components/optimization/ErrorFallback';
import { DashboardHeader } from './components/DashboardHeader';

export const Dashboard: React.FC = React.memo(() => {
  const navigate = useNavigate();
  const { showOnboarding, completeOnboarding } = useOnboarding();
  const { config, getWelcomeMessage } = useDashboardPersonalization();
  

  const handleNavigation = React.useCallback((path: string) => {
    navigate(path);
  }, [navigate]);

  const memoizedWelcomeMessage = React.useMemo(() => {
    return getWelcomeMessage();
  }, [getWelcomeMessage]);

  return (
    <ErrorBoundary FallbackComponent={(props) => <ErrorFallback {...props} componentName="Dashboard" />}>
      <div className="h-full p-4 sm:p-6 space-y-4 sm:space-y-6 animate-fade-in overflow-auto bg-gradient-to-br from-primary/5 via-secondary/30 to-accent/10">
        <DashboardHeader
          title={config.simplifiedInterface ? 'My Fitness Journey' : 'FitAI Coach Dashboard'}
          subtitle="AI-powered fitness coaching"
          welcomeMessage={memoizedWelcomeMessage}
          showEncouragement={config.showEncouragement}
        />

        <DashboardSections />
        
        <div className="hidden md:block">
          <PersonalizationDebugger />
        </div>

        {/* Onboarding Flow - Only for new users */}
        {config.showOnboarding && (
          <OnboardingFlow open={showOnboarding} onComplete={completeOnboarding} />
        )}
      </div>
    </ErrorBoundary>
  );
});
